define( function() {
	"use strict";

	return ( /^$|^module$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/jquery@3.7.0/node_modules/jquery/src/manipulation/var/rscriptType.js
// module id = VrTd
// module chunks = 1 2